import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = `${BACKEND_URL}/api`;

export const QuickQuoteForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    homeValue: '',
    mortgageBalance: '',
    age: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await axios.post(`${API}/quick-quote`, formData);
      window.location.href = '/thank-you';
    } catch (error) {
      // Error logged silently - user sees alert
      alert('Failed to submit. Please call us directly at (720) 307-8711');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="bg-white rounded-2xl shadow-2xl p-6 border border-gray-100">
      <h3 className="text-xl font-bold text-gray-900 mb-4">Get Your Free Analysis</h3>
      <form onSubmit={handleSubmit} className="space-y-3">
        <div>
          <Label htmlFor="quick-name" className="text-sm font-semibold">Name</Label>
          <Input
            id="quick-name"
            name="name"
            type="text"
            required
            value={formData.name}
            onChange={handleChange}
            className="mt-1"
            placeholder="John Smith"
          />
        </div>

        <div>
          <Label htmlFor="quick-email" className="text-sm font-semibold">Email</Label>
          <Input
            id="quick-email"
            name="email"
            type="email"
            required
            value={formData.email}
            onChange={handleChange}
            className="mt-1"
            placeholder="john@example.com"
          />
        </div>

        <div>
          <Label htmlFor="quick-phone" className="text-sm font-semibold">Phone</Label>
          <Input
            id="quick-phone"
            name="phone"
            type="tel"
            required
            value={formData.phone}
            onChange={handleChange}
            className="mt-1"
            placeholder="(720) 555-0123"
          />
        </div>

        <div>
          <Label htmlFor="quick-homeValue" className="text-sm font-semibold">Home Value</Label>
          <Input
            id="quick-homeValue"
            name="homeValue"
            type="text"
            required
            value={formData.homeValue}
            onChange={handleChange}
            className="mt-1"
            placeholder="$400,000"
          />
        </div>

        <div>
          <Label htmlFor="quick-mortgageBalance" className="text-sm font-semibold">Mortgage Balance</Label>
          <Input
            id="quick-mortgageBalance"
            name="mortgageBalance"
            type="text"
            required
            value={formData.mortgageBalance}
            onChange={handleChange}
            className="mt-1"
            placeholder="$150,000"
          />
        </div>

        <div>
          <Label htmlFor="quick-age" className="text-sm font-semibold">Your Age</Label>
          <Input
            id="quick-age"
            name="age"
            type="number"
            required
            min="55"
            max="110"
            value={formData.age}
            onChange={handleChange}
            className="mt-1"
            placeholder="65"
          />
        </div>

        <Button 
          type="submit" 
          size="lg" 
          disabled={isSubmitting}
          className="w-full bg-green-600 hover:bg-green-700 py-5"
        >
          {isSubmitting ? 'Submitting...' : 'Get Free Analysis'}
        </Button>

        <p className="text-xs text-center text-gray-500">
          No obligation • Private consultation
        </p>
      </form>
    </div>
  );
};
